
<div class="users-header-container">
  <h3 class="header-title">Users</h3>
  <button class="primary-button" nz-button nzSize="default" nzType="primary" nzDanger (click)="openCreateCustomersUserModal(tplContent, tplFooter)">
    <span nz-icon nzType="plus" nzTheme="outline"></span>
    Add new user
  </button>
</div>
<nz-table
  [nzLoading]="isLoading"
  [nzData]="users"
  [nzShowPagination]="false"
  [nzFrontPagination]="false"
  [nzSize]="'small'"
>
  <thead>
  <tr>
    <th>Name</th>
    <th>Email</th>
    <th>Created at</th>
    <th>Last visit</th>
    <th></th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let user of users">
    <td><span class="user-name-column">{{ user.name}} <img *ngIf="customer.admin_email.toLowerCase() === user.email.toLowerCase()" src="assets/crown.svg" alt="crown" width="16px"></span></td>
    <td>{{ user.email }}</td>
    <td>{{ user.created_at | yomaDateFormat:'dd.MM.yyyy HH:mm'}}</td>
    <td>{{ user.last_visit | yomaDateFormat:'dd.MM.yyyy HH:mm' }}</td>
    <td class="actions-column">
      @if(customer.admin_email.toLowerCase() === user.email.toLowerCase()) {
        <button nz-button class="crown" nzType="text" nz-tooltip="Transfer ownership" (click)="openTransferOwnershipModal(transferOwnershipTplContent, transferOwnershipTplFooter)">
          <span nz-icon nzType="arrows-alt"></span>
        </button>
      } @else {
        <button nz-button nzType="text" (click)="deleteUser(user)">
          <span nz-icon nzType="delete"></span>
        </button>
      }
      <button nz-button nzType="text" nz-tooltip="Login as user" (click)="createImpersonateLink(user)">
        <span nz-icon nzType="link"></span>
      </button>
    </td>
    <td>
  </tr>
  </tbody>
</nz-table>


<ng-template #tplContent>
  <form nz-form [formGroup]="userForm">
    <nz-form-label class="feature-form-label" nzRequired>User name</nz-form-label>
    <nz-form-item>
      <nz-form-control nzHasFeedback nzErrorTip="Name is required">
        <input nz-input formControlName="name" name="user_name" required="true" placeholder="Name"/>
      </nz-form-control>
    </nz-form-item>
    <nz-form-label class="feature-form-label" nzRequired>User email</nz-form-label>
    <nz-form-item>
      <nz-form-control nzHasFeedback nzErrorTip="Email is required">
        <input nz-input formControlName="email" name="user_email" required="true" placeholder="Email"/>
      </nz-form-control>
    </nz-form-item>
    <nz-form-label class="feature-form-label" nzRequired>User role</nz-form-label>
    <nz-form-item>
      <nz-select nzPlaceHolder="Role" formControlName="role_id" required="true" style="width: 100%;">
        @for (role of roles; track $index){
          <nz-option [nzLabel]="role.name" [nzValue]="role.role_id"></nz-option>
        }
      </nz-select>
    </nz-form-item>
  </form>
</ng-template>

<ng-template #tplFooter let-ref="modalRef">
  <button nz-button (click)="handleModalClose(ref)" class="form-button">Cancel</button>
  <button
    [disabled]="userForm.invalid"
    nzType="primary"
    [nzLoading]="isCreatingUserLoading"
    nz-button
    class="form-button"
    nzDanger
    (click)="save(ref)"
    >
    Create
  </button>
</ng-template>

<ng-template #transferOwnershipTplContent>
  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select user" [(ngModel)]="selectedUser" style="width: 300px">
    @for (user of users; track $index){
      @if (customer.admin_email !== user.email){
        <nz-option [nzLabel]="user.name" [nzValue]="user"></nz-option>
      }
    }
  </nz-select>
</ng-template>

<ng-template #transferOwnershipTplFooter let-ref="modalRef">
  <button nz-button (click)="handleModalClose(ref)" class="form-button">Cancel</button>
  <button
    nzType="primary"
    nz-button
    nzDanger
    class="form-button"
    [nzLoading]="transferOwnershipLoading"
    [disabled]="!selectedUser"
    (click)="transferOwnership(ref)"
  >
    Transfer ownership
  </button>
</ng-template>
